<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="TQC售后出错责任 center_7"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
      :tooltipText="'售后统计实时数据'"
    ></chart-title>
    <date-change-card
      style="padding: 0 10px"
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="center_7" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { personType } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import {formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "center_7",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      date: new Date(),
      chart: null,
      chartData: [
        "门市",
        "外协",
        "原材料",
        "设计师",
        "转图",
        "车间",
        "审图",
        "安装",
        "运输",
        "软件",
        "其他",
      ],
      typeList: ["重做订单", "返工订单", "订单合计"],
      czList: [],
      fgList: [],
      hjList: [],
      totalNum: 0
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData(){

      this.totalNum = 0; //初始化数据

      //获取ERP 接口数据
      personType(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        //处理数据
        for (let i = 0;i < this.chartData.length; i++){
          this.czList[i] = 0; //重做数据
          this.fgList[i] = 0; //返工数据
          this.hjList[i] = 0; //合计数据
          for(let key in resp.data){
            if(key === this.chartData[i]+'出错'){

              if(resp.data[key].返工){
                this.fgList[i] = resp.data[key].返工;
                this.hjList[i] += resp.data[key].返工;
                this.totalNum += resp.data[key].返工;
              }

              if(resp.data[key].重做){
                this.czList[i] = resp.data[key].重做;
                this.hjList[i] += resp.data[key].重做;
                this.totalNum += resp.data[key].重做;
              }
              break;
            }
          }
        }

        this.initChart();
      });

    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_7"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "12%",
          bottom: "16%",
          containLabel: true,
        },
        legend: {
          data: this.typeList,
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "重做订单",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(21,157,255,0.1)" },
                { offset: 1, color: "rgba(21,157,255,1)" },
              ]),
            },
            data: this.czList,
          },
          {
            name: "返工订单",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(34,228,255,0.1)" },
                { offset: 1, color: "rgba(34,228,255,1)" },
              ]),
            },
            data: this.fgList,
          },
           {
             name: "订单合计",
             type: "line",
             yAxisIndex: 1,
             data: this.hjList,
             showAllSymbol: true,
             symbol: "emptyCircle",
             symbolSize: 6,
             color:"#3bffd0"
           },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"),  +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 26vh;
  #center_7 {
    height: 100%;
  }
}
</style>
